import React from 'react'
import PropTypes from 'prop-types'
import './index.css'
import Icon from '../Icon'
import CategorySlider from '../VoidPLP/components/CategorySlider'
import ProductSlider from '../VoidPLP/components/ProductSlider'
import { useIsTenant } from '../../contexts/TenantContext'
import constants from '../../common/constants'
import RenderInnerHTML from 'Src/components/RenderInnerHTML'
import getConfig from '../../../src/Helpers/getConfig'

const VoidPage = ({ title, subtitle, message, categories, relatedProduct, isMobile }) => {
  const isTenantCatalogo = useIsTenant(constants.tenant.CATEX)
  const isWalstore = getConfig('isWalstore')

  const configData = window.__ENV__
  const voidPLP = 'voidPLP'

  const displayCategorySliderForCatalogo = () =>
    (isTenantCatalogo ? (
      <CategorySlider isMobile={isMobile} products={relatedProduct} categories={categories} configData={configData} />
    ) : null)

  return (
    <div className="app-container void-plp__page">
      <div className="rct-page_cat">
        <div className="rct-page-content">
          <section className="bs__card">
            <div className="bs__card__body bs__color-bg-info text-center">
              <div className="bs__rounded-container">
                <Icon name={isWalstore ? 'computerWalestore' : 'manExplode'} />
              </div>
              <h2 className="void-plp__page__title">{title}</h2>
              <h3>{isWalstore ? <RenderInnerHTML html={subtitle} /> : subtitle}</h3>
              <span
                className={`bs__vertical-separator--warning ${
                  relatedProduct.length > 0 && 'bs__vertical-separator--min'
                }`}
              />
              <div className="void-plp__page__mesagge">{relatedProduct.length === 0 && message}</div>
            </div>
            {relatedProduct.length === 0 && displayCategorySliderForCatalogo()}
          </section>
          <div>
            {relatedProduct.length > 0 && (
              <ProductSlider origin={voidPLP} products={relatedProduct} isMobile={isMobile} />
            )}
          </div>
          {relatedProduct.length > 0 && displayCategorySliderForCatalogo()}
        </div>
      </div>
    </div>
  )
}

VoidPage.defaultProps = {
  categories: [],
  relatedProduct: [],
  isMobile: false,
}

VoidPage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  message: PropTypes.any.isRequired,
  categories: PropTypes.array,
  relatedProduct: PropTypes.array,
  isMobile: PropTypes.bool,
}

export default VoidPage
